import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, DownloadIcon, EyeOffIcon, FileTextIcon, WrenchIcon, CheckIcon, LockIcon } from 'lucide-react';
export function PriceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const orderItems = [{
    label: 'The Concrete Bunker Blueprint (Main Guide)',
    value: '$97',
    icon: FileTextIcon
  }, {
    label: 'BONUS #1 — The "Gray Man" Procurement Guide',
    value: '$47',
    icon: EyeOffIcon
  }, {
    label: 'BONUS #2 — Tool-Free Installation Blueprints',
    value: '$37',
    icon: WrenchIcon
  }, {
    label: 'BONUS #3 — Decoy Safe Strategy Manual',
    value: '$29',
    icon: ShieldCheckIcon
  }];
  const trustBadges = [{
    icon: DownloadIcon,
    label: 'Instant Download'
  }, {
    icon: EyeOffIcon,
    label: 'No Paper Trail'
  }, {
    icon: LockIcon,
    label: 'Secure Checkout'
  }, {
    icon: ShieldCheckIcon,
    label: '60-Day Guarantee'
  }];
  return <section id="checkout" ref={ref} className="w-full bg-dark-section py-20 md:py-28" data-id="element-172">
      <div className="max-w-2xl mx-auto px-6" data-id="element-173">
        {/* Headline */}
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          <span className="inline-block px-3 py-1 text-xs font-inter font-bold tracking-[0.2em] text-orange-accent uppercase border border-orange-accent/50 bg-orange-accent/10 mb-4" data-id="element-175">
            COMPLETE YOUR ORDER
          </span>
          <h2 className="font-bebas text-4xl md:text-5xl text-white tracking-wide" data-id="element-176">
            STOP BEING A TARGET.{' '}
            <span className="text-orange-accent" data-id="element-177">START BEING A GHOST.</span>
          </h2>
        </motion.div>

        {/* Order card */}
        <motion.div className="bg-dark-card border border-white/10 overflow-hidden" initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-178">
          {/* Card header */}
          <div className="px-6 py-4 bg-dark-bg border-b border-white/5" data-id="element-179">
            <p className="font-inter text-xs font-semibold tracking-[0.2em] text-concrete/60 uppercase" data-id="element-180">
              Order Summary
            </p>
          </div>

          {/* Line items */}
          <div className="divide-y divide-white/5" data-id="element-181">
            {orderItems.map((item, index) => <motion.div key={item.label} className="flex items-center justify-between px-6 py-4 gap-4" initial={{
            opacity: 0,
            x: -10
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -10
          }} transition={{
            duration: 0.4,
            delay: 0.25 + index * 0.08
          }} data-id="element-182">
                <div className="flex items-center gap-3" data-id="element-183">
                  <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30" data-id="element-184">
                    <CheckIcon className="w-3.5 h-3.5 text-orange-accent" data-id="element-185" />
                  </div>
                  <span className="font-inter text-sm text-white leading-snug" data-id="element-186">
                    {item.label}
                  </span>
                </div>
                <span className="font-inter text-sm text-concrete/50 line-through flex-shrink-0" data-id="element-187">
                  {item.value}
                </span>
              </motion.div>)}
          </div>

          {/* Totals */}
          <motion.div className="border-t border-white/10 px-6 py-5 bg-dark-bg/50" initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} data-id="element-188">
            <div className="flex items-center justify-between mb-3" data-id="element-189">
              <span className="font-inter text-sm text-concrete" data-id="element-190">
                Total Value
              </span>
              <span className="font-inter text-sm text-concrete/50 line-through" data-id="element-191">
                $210
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-192">
              <span className="font-inter text-base font-semibold text-white" data-id="element-193">
                Your Price Today
              </span>
              <motion.span className="font-bebas text-4xl text-orange-accent tracking-wider" initial={{
              opacity: 0,
              scale: 0.8
            }} animate={isInView ? {
              opacity: 1,
              scale: 1
            } : {
              opacity: 0,
              scale: 0.8
            }} transition={{
              duration: 0.5,
              delay: 0.75,
              type: 'spring',
              stiffness: 200,
              damping: 15
            }} data-id="element-194">
                $6.36
              </motion.span>
            </div>
            <p className="font-inter text-xs text-concrete/50 mt-2" data-id="element-195">
              One-time payment · No subscription · No recurring fees
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div className="px-6 pb-6 pt-4" initial={{
          opacity: 0,
          y: 10
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 10
        }} transition={{
          duration: 0.5,
          delay: 0.85
        }} data-id="element-196">
            <motion.button onClick={() => window.open('https://www.betterbysteps.com/cart/44211527909469:1', '_blank')} className="group relative w-full inline-flex items-center justify-center gap-3 px-8 py-5 bg-orange-accent text-white font-inter font-bold text-lg uppercase tracking-wide rounded-sm overflow-hidden transition-all duration-300 hover:bg-orange-accent/90 hover:scale-[1.01] active:scale-[0.99]" whileHover={{
            boxShadow: '0 0 40px rgba(224, 123, 57, 0.45)'
          }} data-id="element-197">
              <span data-id="element-198">SECURE YOUR COPY NOW — $6.36</span>
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-199" />
              <motion.span className="absolute inset-0 border-2 border-orange-accent rounded-sm" animate={{
              scale: [1, 1.04, 1],
              opacity: [0.4, 0, 0.4]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-200" />
            </motion.button>
          </motion.div>
        </motion.div>

        {/* Trust badges */}
        <motion.div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6" initial={{
        opacity: 0,
        y: 10
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.5,
        delay: 1
      }} data-id="element-201">
          {trustBadges.map(badge => <div key={badge.label} className="flex flex-col items-center gap-2 py-3 px-2 bg-dark-card border border-white/5" data-id="element-202">
              <badge.icon className="w-5 h-5 text-orange-accent" data-id="element-203" />
              <span className="font-inter text-xs text-concrete/70 text-center leading-tight" data-id="element-204">
                {badge.label}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}